import ProgressBar from './progressBar';

class Attempt extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  currentLegend(score) {
    const { legend } = this.props;

    const legendIndex = legend.map(item => item.score.value);
    if (!legendIndex.includes(score)) legendIndex.push(score);

    const index = legendIndex.sort((a, b) => b - a).findIndex(legendValue => legendValue == score)

    return legend[index];
  }

  render() {
    const { value, index, className = "", highlight, animate } = this.props;
    const [attemptIndex, word, score, proximity, _] = value;
    const currentLegend = this.currentLegend(score);
    return (
      <tr className={`${className} ${highlight ? 'bg-warning-light' : index % 2 == 0 ? '' : 'bg-grey-light bg-opacity-75'}`}>
        <td className="text-left py-2 px-3">{attemptIndex}</td>
        <td className="text-left py-2 whitespace-no-wrap">{word}</td>
        <td className="text-right py-2 pr-4">{(proximity == null || !animate) && ((score * 100).toFixed(2))}</td>
        <td className="text-left py-2">{(proximity == null || !animate) && (currentLegend.icon)}</td>
        <td className="text-left py-2 pr-3"><ProgressBar value={proximity} animate={animate} /></td>
      </tr>
    )
  }
}

export default Attempt;
